import IClaimHwrc from "interfaces/responses/IClaimHwrc";
import { GlobalState } from "little-state-machine";

export const updateCurrentHwrcClaimsRoles = (state: GlobalState, currentHwrcClaimsRoles: IClaimHwrc[]) => ({
  ...state,
  currentHwrcClaimsRoles
});
